import { VeralliaLine } from './verallia-components/VeralliaLine';
// import { VeralliaEventsHistory } from './verallia-components/VeralliaEventsHistory';
// import { getInfluxdbData } from '../../services/api/influxdb-tools';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSocket } from '../../contexts/SocketContext';

/*
const formatEventsHistoryData = (data) => data.filter((event) => event.detected).map((event) => ({
  id: `${event.pallet_id}-${event.client_id}-${event.time}-${event.face}-${event.defect_type}`,
  line: parseInt(event.line.replace('line_', '')),
  pallet_id: event.pallet_id,
  client_id: event.client_id,
  face: event.face === 'null' || event.face === null ? null : parseInt(event.face),
  defect_type: parseInt(event.defect_type),
  time: Math.floor(new Date(event.time).getTime() / 1000)
}));
*/

export const VeralliaLivePage = () => {
  const { screen } = useParams();
  const screenId = screen ? parseInt(screen) : 1;

  const { socket, subscribeToEvent, unsubscribeFromEvent } = useSocket();
  const [pallets, setPallets] = useState([]);

  /*
  const [events, setEvents] = useState([]);
  const [isEventsLoading, setIsEventsLoading] = useState(true);

  const updateEventsHistory = async () => {
    setIsEventsLoading(true);

    try {
      const eventsData = await getInfluxdbData('engine', 'pallet_defect', [], [], '-1w', 'now()', '1ms', null, null, [], null, null, false, 'desc');
      setEvents(formatEventsHistoryData(eventsData));
    } catch (error) {
      console.error('Unable to load Verallia events history:', error);
      setEvents([]);
    } finally {
      setIsEventsLoading(false);
    }
  };

  useEffect(() => {
    updateEventsHistory();
  }, []);
  */

  useEffect(() => {
    if (!socket) return undefined;

    const handleReceivedData = (data) => {
      if (data?.pallets !== undefined) setPallets(Array.isArray(data.pallets) ? data.pallets : []);
    };

    subscribeToEvent('current_data', handleReceivedData);
    return () => unsubscribeFromEvent('current_data', handleReceivedData);
  }, [socket, subscribeToEvent, unsubscribeFromEvent]);

  const line1Pallets = pallets.filter((pallet) => pallet.line === 'line_1');
  const line2Pallets = pallets.filter((pallet) => pallet.line === 'line_2');
  const line3Pallets = pallets.filter((pallet) => pallet.line === 'line_3');

  return (
    <div className="h-full p-4">
      <div className="h-full min-h-0 w-full">
        <div className="flex h-full min-h-0 flex-col justify-center gap-4">
          {screenId === 1 ? (
            <>
              <div className="min-h-0 flex-1">
                <VeralliaLine lineId={1} pallets={line1Pallets} />
              </div>

              <div className="min-h-0 flex-1">
                <VeralliaLine lineId={2} pallets={line2Pallets} />
              </div>
            </>
          ) : (
            <div className="min-h-0 flex-1">
              <VeralliaLine lineId={3} pallets={line3Pallets} />
            </div>
          )}
        </div>
      </div>

      {/*
      <div className="min-h-0 overflow-y-auto portrait:flex-1 portrait:w-full landscape:h-full landscape:w-1/4">
        <VeralliaEventsHistory events={events} isLoading={isEventsLoading} />
      </div>
      */}
    </div>
  );
};